import React from 'react';
import { OptionCycler } from '../components/OptionCycler';
import { ACCESSORIES, TRAILS } from '../CharacterCustomizer.constants';
import { TabProps } from './types';

export const StyleTab: React.FC<TabProps> = ({ appearance, setAppearance }) => {
  return (
    <div className="cc-section cc-field-grid">
      <div className="cc-input-group">
        <label className="cc-label">Head Accessory</label>
        <OptionCycler
          label="head accessory"
          value={appearance.accessory || 'none'}
          options={ACCESSORIES}
          onChange={v => setAppearance((p: any) => ({ ...p, accessory: v as any }))}
        />
      </div>
      <div className="cc-input-group">
        <label className="cc-label">Trail Effect</label>
        <OptionCycler
          label="trail effect"
          value={appearance.trail || 'none'}
          options={TRAILS}
          onChange={v => setAppearance((p: any) => ({ ...p, trail: v as any }))}
        />
      </div>
    </div>
  );
};
